<template>
    <va-card class="flex mb-4">
        <va-card-title style="height: 30px; padding: 5px; padding-left: 20px"
            >本地执行记录</va-card-title
        >
        <va-card-content>
            <div>
                <div>
                    <vxe-form :data="toolbar.formData">
                        <vxe-form-item
                            title="状态"
                            field="status"
                            :item-render="{}"
                        >
                            <template #default="{ data }">
                                <vxe-select
                                    v-model="data.status"
                                    placeholder="全部"
                                    clearable
                                    style="width: 100px"
                                >
                                    <vxe-option
                                        value="1"
                                        label="运行中"
                                    ></vxe-option>
                                    <vxe-option
                                        value="4"
                                        label="运行异常"
                                    ></vxe-option>
                                    <vxe-option
                                        value="5"
                                        label="运行完成"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="关键字"
                            field="searchKey"
                            :item-render="{}"
                        >
                            <template #default="{ data }">
                                <vxe-input
                                    v-model="data.searchKey"
                                    placeholder="请输入项目名称或ID"
                                    clearable
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item>
                            <template #default>
                                <vxe-button
                                    status="primary"
                                    @click="findData"
                                    @keyup.enter="findData"
                                    >查询</vxe-button
                                >
                                <vxe-button @click="clear">重置</vxe-button>
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </div>
                <div style="overflow: hidden; height: 100%">
                    <vxe-table
                        stripe
                        class="mytable-scrollbar"
                        :data="tableData"
                        :cell-style="cellStyle"
                        :height="tableHeight"
                        show-overflow
                        :row-config="{
                            height: 36,
                            isHover: true,
                            isCurrent: true,
                        }"
                        ref="xTable1"
                    >
                        <vxe-column
                            type="seq"
                            field="Id"
                            title="序号"
                            width="50"
                        ></vxe-column>

                        <vxe-column
                            field="StateName"
                            title="状态"
                            width="100"
                            align="center"
                        ></vxe-column>
                        <vxe-column
                            field="CreatorUserId"
                            title="邮箱"
                            width="180"
                            sortable
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="UserName"
                            title="姓名"
                            width="100"
                            align="center"
                            sortable
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="ProcessID"
                            title="项目ID"
                            width="130"
                            show-overflow
                            resizable
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="ProcessName"
                            title="项目名称"
                            width="220"
                            resizable
                            sortable
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="StartTime"
                            title="开始时间"
                            width="160"
                        ></vxe-column>
                        <vxe-column
                            field="EndTime"
                            title="结束时间"
                            width="160"
                        ></vxe-column>
                         <vxe-column
                            field="realPlatformName"
                            title="开发平台"
                            width="120"
                        ></vxe-column>
                        <vxe-column
                            field="localAppType"
                            title="本地程序类型"
                            width="120"
                            resizable
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="localAppPath"
                            title="本地程序"
                            width="120"
                            resizable
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="localExeFile"
                            title="本地程序文件"
                            width="120"
                            resizable
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="localExeParam"
                            title="本地程序参数"
                            width="120"
                            resizable
                            show-overflow
                        ></vxe-column>
                    </vxe-table>
                </div>
                <div>
                    <vxe-pager
                        background
                        v-model:current-page="tablePager.currentPage"
                        v-model:page-size="tablePager.pageSize"
                        :total="tablePager.totalResult"
                        @page-change="handlePageChange"
                        :layouts="[
                            'PrevJump',
                            'PrevPage',
                            'JumpNumber',
                            'NextPage',
                            'NextJump',
                            'Sizes',
                            'FullJump',
                            'Total',
                        ]"
                    >
                    </vxe-pager>
                </div>
            </div>
        </va-card-content>
    </va-card>
</template>

<script>
import Qs from "qs";
import { reactive } from "vue";
import XEUtils from "xe-utils";
import { VXETable, VxeTableInstance, VxeTablePropTypes } from "vxe-table";

export default {
    name: "JobListLocal",
    data() {
        const pageHeight = window.innerHeight - (65 + 48 + 198) + "px"; //屏幕高度减去导航栏和内补白
        const tablePager = reactive({
            currentPage: 1,
            pageSize: 10,
            totalResult: 0,
        });
        const toolbar = reactive({
            loading: false,
            macOptions: [],
            formData: {
                selectMac: "",
                status: "",
                searchKey: "",
            },
        });

        const logForm = reactive({
            dtLog: [],
            iShow: false, //显示更新包
            pager: {
                currentPage: 1,
                pageSize: 10,
                totalResult: 0,
            },
        });
        const cellStyle = ({ row, column }) => {
            if (column.field === "StateName") {
                if (row.StateName === "运行完成") {
                    return {
                        color: "#008000",
                    };
                } else if (row.StateName === "运行异常") {
                    return {
                        color: "#FF0000",
                    };
                } else {
                    return {
                        color: "#0000FF",
                    };
                }
            }
        };

        return {
            tableData: null,
            tablePager,
            toolbar,
            pageHeight,
            logForm,
            cellStyle,
            tableHeight: 0,
        };
    },
    methods: {
        findData() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: this.tablePager.currentPage,
                pageSize: this.tablePager.pageSize,
                searchKey: [
                    this.toolbar.formData.searchKey,
                    this.toolbar.formData.status
                ],
            };
            this.$api.jobManageAPI
                .getJobsListLocal(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.tableData = res.data.Data.dataTable;
                    this.tablePager.currentPage = res.data.Data.currentPage;
                    this.tablePager.pageSize = res.data.Data.pageSize;
                    this.tablePager.totalResult = res.data.Data.totalResult;
                    // debugger;
                    this.tableHeight = this.$calTableHeight(
                        res.data.Data.dataTable.length
                    );
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        async stopEvent(row) {
            const type = await VXETable.modal.confirm("您确定要停止该作业吗?");

            if (type === "confirm") {
                this.$api.jobManageAPI
                    .stopJobLocal(Qs.stringify({ jobId: row.Id }))
                    .then((res) => {
                        if (res.data.Success == false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            return;
                        }
                        VXETable.modal.message({
                            content: "停止成功",
                            status: "success",
                        });
                        this.findData();
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        },
        handlePageChange() {
            this.findData();
        },
        clear() {
            this.toolbar.formData.searchKey = "";
            this.toolbar.formData.status = "";
        },
        keydown(e) {
            if (e.keyCode === 13) {
                this.findData();
            }
        },
        calTableHeight(rowsLength) {
            let minHeight = window.innerHeight - (65 + 28 + 198);
            let calHeight = rowsLength == null ? 0 : (rowsLength + 1) * 36 + 22;
            this.tableHeight = Math.max(minHeight, calHeight);
        },
    },
    mounted() {
        this.findData();
        window.addEventListener("keydown", this.keydown);
    },
    unmounted() {
        window.removeEventListener("keydown", this.keydown, false);
    },
};
</script>

<style scoped>
.active {
    color: green;
    font-weight: bold;
}

.error {
    color: red;
    font-weight: bold;
}

.audit {
    color: blue;
    font-weight: bold;
}
</style>

<style type="text/css">
td.vxe-body--column {
    vertical-align: middle;
}
</style>
